import { Instance } from 'mobx-state-tree';
import { DriverDeletedDtoModelBase } from './DriverDeletedDtoModel.base';

/* The TypeScript type of an instance of DriverDeletedDtoModel */
export interface DriverDeletedDtoModelType extends Instance<typeof DriverDeletedDtoModel.Type> {}

/* A graphql query fragment builders for DriverDeletedDtoModel */
export { selectFromDriverDeletedDto, driverDeletedDtoModelPrimitives, DriverDeletedDtoModelSelector } from './DriverDeletedDtoModel.base';

/**
 * DriverDeletedDtoModel
 */
export const DriverDeletedDtoModel = DriverDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
